
"use strict";
const EUR = n => "€ " + Math.round(n).toLocaleString("de-DE");
const euroC = n => "€" + Number(n).toLocaleString("de-DE",{minimumFractionDigits:2,maximumFractionDigits:2});

/* ====== Verkaufs-Gehirn: Eignungs-Gewichte je Modell (Handle). Rest kommt live aus dem Shop. ====== */
let MODELS=[], IMG={}, SEAL={}, REVIEWS={}, VID={};
const PROFILES={
 aero_wt:{short:"Aero-Allrounder, optimiert für 28-mm-Reifen",char:{komfort:.6,allround:.9,performance:.72},terr:{flach:.85,huegelig:.72,bergig:.5}},
 endurance:{short:"Komfortabler Allrounder für Straße und leichtes Gelände",char:{komfort:.95,allround:.82,performance:.42},terr:{flach:.55,huegelig:.82,bergig:.9,leicht:.8,gemischt:.72,grob:.5}},
 aero_wide:{short:"Aero-Laufradsatz mit breiter Maulweite für 29–35-mm-Reifen",char:{komfort:.9,allround:.9,performance:.6},terr:{flach:.72,huegelig:.82,bergig:.72}},
 aero_wt_s:{short:"Leichter Aero-Laufradsatz, optimiert für 28-mm-Reifen",shortVs:{aero_wt:"Die leichtere Variante der Aero WT, ebenfalls optimiert für 28-mm-Reifen"},char:{komfort:.7,allround:.86,performance:.95},terr:{flach:.9,huegelig:.8,bergig:.72}},
 aero_wide_s:{short:"Leichte Aero-Variante mit breiter Maulweite für 29–35-mm-Reifen",char:{komfort:.72,allround:.9,performance:.92},terr:{flach:.85,huegelig:.82,bergig:.72}},
 aero_cs:{short:"Unser aerodynamischstes Setup mit Carbonspeichen",char:{komfort:.6,allround:.76,performance:1.0},terr:{flach:1.0,huegelig:.8,bergig:.72}},
 explore:{short:"Robuster Gravel-Allrounder für viele Untergründe",char:{komfort:.85,allround:.8,performance:.5},terr:{leicht:.9,gemischt:.8,grob:.58,flach:.6,huegelig:.65,bergig:.6}},
 gcx_terra:{short:"Sportlicher Gravel-Laufradsatz für gemischtes Terrain",char:{komfort:.6,allround:.9,performance:.86},terr:{leicht:.78,gemischt:.9,grob:.72}},
 gcx_terra_ultra:{short:"Extra breite Felge für 50–65-mm-Reifen und rauen Untergrund",char:{komfort:.95,allround:.75,performance:.6},terr:{leicht:.35,gemischt:.7,grob:1.0}},
 gcx_terra_max:{short:"Für grobes, technisches Terrain und breite Reifen",char:{komfort:.86,allround:.85,performance:.7},terr:{leicht:.5,gemischt:.8,grob:1.0}},
 gcx_terra_travel:{short:"Robust für Bikepacking und Gepäck (bis 150 kg)",char:{komfort:.82,allround:.86,performance:.5},terr:{leicht:.72,gemischt:.85,grob:.8}},
 gcx_terra_luminate:{short:"Für lange Touren mit Nabendynamo",char:{komfort:.82,allround:.8,performance:.5},terr:{leicht:.8,gemischt:.8,grob:.7}},
};
const PROFILE_DEFAULT={short:"",char:{komfort:.7,allround:.8,performance:.7},terr:{flach:.7,huegelig:.75,bergig:.7,leicht:.75,gemischt:.8,grob:.7}};
function parseNum(s){ const m=String(s==null?'':s).match(/\d+/); return m?+m[0]:null; }
function parseTireRange(s){ const n=(String(s==null?'':s).match(/\d+/g)||[]).map(Number); if(n.length>=2)return [n[0],n[1]]; if(n.length===1)return /\+/.test(String(s))?[n[0],n[0]+20]:[n[0],n[0]]; return [28,32]; }
function bandHeights(hs,tag){ const mid=hs[Math.floor((hs.length-1)/2)];
  const tagged=w=>hs.filter(h=>String(tag[h]||'').indexOf(w)>=0);
  const near=(a,t)=>a.length?a.reduce((x,y)=>Math.abs(y-t)<Math.abs(x-t)?y:x):null;
  const k=tagged('komfort'),a=tagged('allround'),p=tagged('performance');
  return {komfort:(k.length?k[0]:hs[0]), allround:(a.length?near(a,mid):mid), performance:(p.length?p[0]:hs[hs.length-1])}; }
function initShopify(){
  MODELS=[]; WEIGHTS={}; SYSMAX={}; SPOKE_MODELS={}; IMG={}; SEAL={}; REVIEWS={}; VID={};
  const D=(window.AERYCS_DATA||{}); const list=D.models||[];
  list.forEach(pm=>{
    const id=pm.id; if(!id) return;
    const disc=(pm.disc&&pm.disc.length)?pm.disc:["road"];
    const byH={}; (pm.variants||[]).forEach(v=>{ const h=+v.h; if(!h)return; (byH[h]=byH[h]||[]).push(v); });
    const hs=Object.keys(byH).map(Number).sort((a,b)=>a-b); if(!hs.length) return;
    WEIGHTS[id]={}; SEAL[id]={}; VID[id]={}; const carbonG={}; const tagByH={};
    let steelPrice=Infinity, carbonPrice=Infinity, steelSpokes="", carbonSpokes="", carbonExists=false;
    hs.forEach(h=>{ const vs=byH[h];
      const steel=vs.find(v=>v.spokeType!=="carbon")||vs[0];
      const carbon=vs.find(v=>v.spokeType==="carbon");
      WEIGHTS[id][h]=+steel.weightG||0;
      VID[id][h]={steel:steel.vid, carbon:carbon&&carbon.vid, imgSteel:steel.image, imgCarbon:carbon&&carbon.image};
      if(+steel.price) steelPrice=Math.min(steelPrice,+steel.price);
      if(steel.spokes) steelSpokes=steel.spokes;
      if(carbon){ carbonExists=true; carbonG[h]=+carbon.weightG||WEIGHTS[id][h]; if(+carbon.price)carbonPrice=Math.min(carbonPrice,+carbon.price); if(carbon.spokes)carbonSpokes=carbon.spokes; }
      const seal=vs.map(v=>v.seal).find(Boolean); if(seal) SEAL[id][h]=seal;
      if(steel.q2) tagByH[h]=steel.q2;
    });
    if(carbonExists) SPOKE_MODELS[id]={steelPrice,carbonPrice,carbonG,steelSpokes,carbonSpokes};
    const rep=byH[hs[0]].find(v=>v.spokeType!=="carbon")||byH[hs[0]][0];
    IMG[id]=rep.image||"";
    SYSMAX[id]=parseNum(rep.sys)||130;
    if(pm.reviews && (+pm.reviews.n>0)) REVIEWS[id]={r:+pm.reviews.r||0, n:+pm.reviews.n||0};
    const prof=PROFILES[id]||PROFILE_DEFAULT;
    MODELS.push({ id, name:pm.name||id, disc, from:isFinite(steelPrice)?steelPrice:0, url:pm.url||"#",
      intro:pm.intro||"", short:(pm.short&&pm.short.trim())||prof.short||"", shortVs:prof.shortVs||{}, hub:rep.hub||"", spokes:steelSpokes||rep.spokes||"",
      tire:rep.tire||prof.tire||"", tireR:parseTireRange(rep.tire||prof.tire), iw:parseNum(rep.iw)||23,
      char:prof.char, terr:prof.terr, heights:bandHeights(hs,tagByH) });
  });
}


/* ---------------- Modelle (echte Shop-Daten) ---------------- */
/* char = Eignung je Charakter (Komfort/Allround/Performance) aus euren guided_shopping-Tags abgeleitet.
   terr = Eignung je Terrain. tire = sinnvolle Reifenbreite [min,max]. heights = reale Felgenhöhen mit q2-Tag. */


/* Reale Gesamtgewichte je Felgenhöhe (g, Scheibenbremse-Varianten; Aero WT S = Stahlspeichen-Basis) */
let WEIGHTS={};
function weightG(id,h){ const w=WEIGHTS[id]||{}; if(w[h]!=null)return w[h];
  const ks=Object.keys(w).map(Number); if(!ks.length)return null;
  ks.sort((a,b)=>Math.abs(a-h)-Math.abs(b-h)); return w[ks[0]]; }
function weightTxt(id,h){ const g=weightG(id,h); return g!=null?g.toLocaleString("de-DE")+" g":null; }
/* Max. Systemgewicht (kg) je Modell – für Schwergewicht-Eignung (Terra Travel = 150) */
let SYSMAX={};
function sysKg(){ return (STATE.weight||75) + (STATE.bikeKg||8.2) + 2; } // +2 kg Kleidung/Zubehör
/* Aero-Neigung aus Fahrergröße/-gewicht: größer/schwerer -> Aero lohnt mehr (-1..+1) */
function aeroBias(){ return Math.max(-1,Math.min(1,(STATE.weight-75)/45 + (STATE.height-178)/45)); }
/* S-Modelle mit zwei Speichen-Ausführungen – Aero identisch, Carbon deutlich leichter + teurer */
let SPOKE_MODELS={};
function budgetCap(){ return (!STATE.budget||STATE.budget==="open")?Infinity:+STATE.budget; }
function spokeVariant(m,h){
  const baseG=weightG(m.id,h); const cfg=SPOKE_MODELS[m.id];
  if(cfg){
    const cg=cfg.carbonG[h]??baseG;
    // Carbonspeichen direkt empfehlen bei Leichtbau-Prioritaet, Rennen oder sehr sportlicher Nutzung (wenn Budget passt)
    const wantCarbon = (STATE.char==="leicht" || useSf()>=0.70) && (cfg.carbonPrice<=budgetCap()) && !entryLevel();
    if(wantCarbon) return {price:cfg.carbonPrice,g:cg,spokes:cfg.carbonSpokes,altNote:`Auch mit Stahlspeichen für ${EUR(cfg.steelPrice)} (+${(baseG-cg).toLocaleString("de-DE")} g).`};
    return {price:cfg.steelPrice,g:baseG,spokes:cfg.steelSpokes,altNote: entryLevel()?null:`Mit Carbonspeichen für ${EUR(cfg.carbonPrice)} sparst du ${(baseG-cg).toLocaleString("de-DE")} g.`};
  }
  return {price:m.from,g:baseG,spokes:m.spokes,altNote:null};
}
/* Leichtbau-Score: leichter = besser (0..1); nutzt die effektive Speichen-Variante */
function lightScore(m,h){ const g=spokeVariant(m,h).g; if(g==null)return 0.5; return Math.max(0,Math.min(1,(1560-g)/(1560-1040))); }
/* Testsiegel je Modell/Höhe (embedded SVG) */
function sealImg(id,h){ return (typeof SEAL!=="undefined" && SEAL[id] && SEAL[id][h]) || null; }

/* ---------------- Flow-Konfiguration ---------------- */
const CHAR_LABEL={komfort:"Komfort",aero:"Aerodynamik",leicht:"Leichtbau"};
const ICON={
  road:'<path d="M3 17h18M6 17l2-10h8l2 10M9 7v10M15 7v10"/>',
  gravel:'<path d="M3 18l5-7 4 5 3-4 6 6M3 18h18"/>',
  flach:'<path d="M3 15h18"/>',
  huegelig:'<path d="M3 16c4 0 4-6 8-6s4 6 10 6"/>',
  bergig:'<path d="M3 18l6-11 5 7 3-4 4 8z"/>',
  leicht:'<path d="M4 16h16M7 16l1-4 4 1 2-3 4 2"/>',
  gemischt:'<path d="M3 17l4-6 4 4 3-5 6 7"/>',
  grob:'<path d="M3 18l3-5 3 3 3-6 3 4 3-2 2 6z"/>',
  komfort:'<path d="M12 21s-7-4.5-7-10a4 4 0 017-2 4 4 0 017 2c0 5.5-7 10-7 10z"/>',
  allround:'<circle cx="12" cy="12" r="8"/><path d="M12 4v16M4 12h16"/>',
  performance:'<path d="M4 13l5 5M4 13l9-9 7 7-9 9-3-3M14 6l4 4"/>',
  aero:'<path d="M3 8h11a2.4 2.4 0 10-2.4-2.4M3 12h16a2.4 2.4 0 11-2.4 2.4M3 16h9"/>',
  leicht:'<path d="M20 4C9 4 5.5 10 5.5 15.5c0 1.6.8 2.7.8 2.7S14 18 17 12c1.8-3.6 3-8 3-8zM7.5 16.5c2.6-4.5 6-6.5 9-7.5"/>',
  komfortC:'<path d="M7.5 18h9a3.6 3.6 0 00.4-7.17A5.4 5.4 0 006 9.2 3.6 3.6 0 007 18z"/>',
  basis:'<circle cx="12" cy="13" r="7"/><path d="M12 13V9.5M9.5 3h5"/>',
  touren:'<circle cx="12" cy="9" r="4"/><path d="M9.5 12.5L8 21l4-2.4L16 21l-1.5-8.5"/>',
  gruppe:'<circle cx="8" cy="9" r="2.6"/><circle cx="16" cy="9" r="2.6"/><path d="M3.5 19c0-2.6 2.4-3.6 4.5-3.6M20.5 19c0-2.6-2.4-3.6-4.5-3.6"/>',
  rennen:'<path d="M6 3v18M6 4h12l-2.5 4L18 12H6"/>',
  bag:'<rect x="6" y="8" width="12" height="12" rx="2"/><path d="M9 8V6a3 3 0 016 0v2"/>',
};
function stepsFor(disc){
  const t = disc==="gravel" ? "untergrund" : "terrain";
  return ["disziplin", t, "reifen", "nutzung", "werte", "charakter", "budget"];
}
const STEP_LABEL={disziplin:"Disziplin",terrain:"Terrain",untergrund:"Untergrund",reifen:"Reifen",nutzung:"Nutzung",werte:"Deine Werte",charakter:"Priorität",budget:"Budget"};
function budgetCount(cap){ const c=cap==="open"?Infinity:+cap; return MODELS.filter(m=>m.disc.includes(STATE.disc)&&m.from<=c).length; }

/* Texte aus dem Customizer (Section-Einstellungen); leer -> Standardtext */
function T(key,def){ const v=((window.AERYCS_TEXT||{})[key]||"").trim(); return v||def; }
function optionsFor(step){
  const c=optionsForBase(step); if(!c) return c;
  c.kicker=T(step+"_kicker",c.kicker); c.title=T(step+"_title",c.title); c.sub=T(step+"_sub",c.sub);
  return c;
}
function optionsForBase(step){
  if(step==="disziplin") return {kicker:"Wo fährst du?",title:"Straße oder Gelände?",
    sub:"Das entscheidet über die komplette Modellauswahl, Reifenfreiheit und Felgenbreite.",
    key:"disc",type:"opt",opts:[
      {v:"road",ic:"road",b:"Straße / Rennrad",s:"Asphalt, schnelle Runden, Touren, Rennen"},
      {v:"gravel",ic:"gravel",b:"Gelände / Gravel",s:"Schotter, Feld & Wald – oft gemischt mit Asphalt"}]};
  if(step==="terrain") return {kicker:"Dein Profil",title:"Wie sieht deine typische Runde aus?",
    sub:"Flaches Terrain belohnt hohe Felgen (Aero), Berge belohnen Leichtbau.",
    key:"terr",type:"opt",opts:[
      {v:"flach",ic:"flach",b:"Flach",s:"Kaum Anstiege, viel Tempo geradeaus"},
      {v:"huegelig",ic:"huegelig",b:"Hügelig",s:"Wellig bis längere Anstiege"},
      {v:"bergig",ic:"bergig",b:"Bergig",s:"Lange Climbs, Alpenpässe"}]};
  if(step==="untergrund") return {kicker:"Dein Untergrund",title:"Wie grob wird's?",
    sub:"Je rauer und technischer, desto mehr Reifenfreiheit und Grip brauchst du.",
    key:"terr",type:"opt",opts:[
      {v:"leicht",ic:"leicht",b:"Leicht",s:"Feldwege, feiner Schotter, viel Asphalt"},
      {v:"gemischt",ic:"gemischt",b:"Gemischt",s:"Klassisches Gravel, wechselnder Untergrund"},
      {v:"grob",ic:"grob",b:"Grob & technisch",s:"Trails, grober Schotter, niedrige Drücke"}]};
  if(step==="reifen"){
    const road = STATE.disc==="road";
    const vals = road?[28,30,32,35]:[35,40,45,50,55,60,65];
    return {kicker:"Reifen",title:"Welche Reifenbreite willst du fahren?",
      sub: (road?"Bestimmt, welche Felgenbreite optimal zu dir passt.":"Mehr Breite = mehr Grip und Komfort im Gelände.")+" Mehrfachauswahl möglich.",
      key:"tire",type:"multi",opts:vals.map(v=>({v,b:v+" mm"}))};
  }
  if(step==="nutzung"){
    const g = STATE.disc==="gravel";
    const opts = g ? [
      {v:"g_touren",ic:"touren",b:"Touren & Erkunden",s:"Entspannt Gelände entdecken, Ausflüge & Genuss."},
      {v:"g_allround",ic:"gravel",b:"Sportliches Gravel",s:"Regelmäßig im Gelände, gemischtes und flottes Terrain."},
      {v:"g_bikepacking",ic:"bag",b:"Bikepacking & lange Touren",s:"Mehrtägig mit Gepäck, Robustheit zählt."},
      {v:"g_race",ic:"rennen",b:"Gravel-Race",s:"Wettkampf und maximale Pace im Gelände."}
    ] : [
      {v:"basis",ic:"basis",b:"Alltag & Training",s:"Pendeln, Training & entspannte Runden – zuverlässig und preiswert."},
      {v:"touren",ic:"touren",b:"Sportliche Touren & RTF",s:"Zügige Ausfahrten, Radtouristik, lange Distanzen."},
      {v:"gruppe",ic:"gruppe",b:"Schnelle Gruppen",s:"Hohes Tempo im Windschatten."},
      {v:"rennen",ic:"rennen",b:"Rennen & Wettkampf",s:"Kriterien, Straßenrennen, TT & Triathlon."}
    ];
    return {kicker:"Nutzung",title:"Wofür möchtest du die Laufräder nutzen?",
      sub:"Mehrfachauswahl möglich – die anspruchsvollste Nutzung bestimmt die Richtung. Daraus schätzen wir auch deine Leistung, ohne dass du FTP oder Watt kennen musst.",
      key:"use",type:"multiTile",opts};
  }
  if(step==="werte") return {kicker:"Ein paar Infos zu dir",title:"Deine Werte",
    sub:"Richtwerte reichen – daraus schätzen wir Systemgewicht und wie sehr sich Aero bzw. Leichtbau lohnt.",
    key:"werte",type:"sliders",sliders:[
      {id:"sw-weight",key:"weight",label:"Gewicht",unit:" kg",min:45,max:130,step:1,sub:"Fahrergewicht ohne Rad."},
      {id:"sw-height",key:"height",label:"Körpergröße",unit:" cm",min:150,max:205,step:1,sub:"Beeinflusst Stirnfläche & Windangriff."}]};
  if(step==="budget") return {kicker:"Budget",title:"Dein Budget pro Laufradsatz?",
    sub:"Die Zahl zeigt, wie viele passende Optionen dir bleiben. Kein Muss – bei „Offen“ gewinnt der beste Fit.",
    key:"budget",type:"budget",opts:[
      {v:"1100",b:"€ 1.100",s:"oder weniger"},
      {v:"1500",b:"€ 1.500",s:"oder weniger"},
      {v:"2000",b:"€ 2.000",s:"oder weniger"},
      {v:"open",b:"Offen",s:"bester Fit gewinnt"}]};
  if(step==="charakter") return {kicker:"Priorität",title:"Was ist dir besonders wichtig?",
    sub:"Das gibt die Richtung deiner Empfehlung vor.",
    key:"char",type:"opt",opts:[
      {v:"aero",ic:"aero",b:"Maximale Aerodynamik",s:"Jedes Watt zählt, Tempo geht vor."},
      {v:"leicht",ic:"leicht",b:"Geringes Gewicht",s:"Leicht am Berg und bei jedem Antritt."},
      {v:"komfort",ic:"komfortC",b:"Komfort & Laufruhe",s:"Ruhig, komfortabel, entspannt lange fahren."}]};
}

/* ---------------- State ---------------- */
let STATE, stepIdx, STEPS;
function resetState(){ STATE={disc:null,terr:null,tire:[],use:[],weight:75,height:178,bikeKg:8.2,char:null,budget:null}; stepIdx=0; STEPS=["disziplin"]; OPEN_CHIP=null; }
const USE_SF={basis:0.42,touren:0.58,gruppe:0.70,rennen:0.86,g_touren:0.45,g_allround:0.62,g_bikepacking:0.50,g_race:0.86};
const USE_AERO={gruppe:1,rennen:1,g_race:1};
const USE_SHORT={basis:"Alltag",touren:"Touren",gruppe:"Gruppen",rennen:"Rennen",g_touren:"Touren",g_allround:"Sportlich",g_bikepacking:"Bikepacking",g_race:"Race"};
function useSf(){ const u=STATE.use||[]; return u.length?Math.max(...u.map(x=>USE_SF[x]||0.5)):0.55; }
function useAero(){ return (STATE.use||[]).some(x=>USE_AERO[x]); }
/* reine Alltag/Training-Nutzung (niedrigste Intensität) -> kein High-End-Satz, keine Carbonspeichen */
function entryLevel(){ const u=STATE.use||[]; return u.length? Math.max(...u.map(x=>USE_SF[x]||0.5))<=0.45 : false; }

/* ---------------- Scoring ---------------- */
function tireText(){ return (STATE.tire&&STATE.tire.length)?[...STATE.tire].sort((a,b)=>a-b).join("/")+" mm":"—"; }
function scoreOneTire(m,t){ const [lo,hi]=m.tireR;
  if(t>=lo&&t<=hi) return 1;
  if(t>hi){ const d=t-hi; return d<=2?0.42:d<=4?0.18:0.06; }   // Reifen breiter als empfohlen -> Felge/Maulweite zu schmal (echter Fehlgriff)
  const d=lo-t; return d<=2?0.72:d<=4?0.42:0.15;               // Reifen schmaler als empfohlen -> weniger kritisch
}
function nearTire(m){
  const sel=STATE.tire&&STATE.tire.length?STATE.tire:[];
  if(!sel.length) return 0.6;                // keine Angabe -> neutral
  return Math.max(...sel.map(t=>scoreOneTire(m,t)));   // passt, wenn IRGENDEINE gewählte Breite passt
}
function pickHeight(m){
  const hs=Object.values(m.heights).sort((a,b)=>a-b);
  const sf=useSf();
  // Gegenläufige Signale heben sich auf -> mittlere Höhe (Allrounder, ~50) ist der sichere Default.
  let aw=0;
  aw += ({flach:0.6,huegelig:0,bergig:-0.6}[STATE.terr] ?? 0);   // Terrain (nur Road)
  aw += ({aero:0.7,komfort:-0.3,leicht:-0.5}[STATE.char] ?? 0);  // Priorität
  aw += (sf-0.55)*1.2;                                           // Nutzungs-Intensität
  aw += aeroBias()*0.4;                                          // Fahrergröße/-gewicht
  const key = aw>=0.6 ? "performance" : aw<=-0.5 ? "komfort" : "allround";
  if(m.heights[key]!=null) return m.heights[key];
  if(key==="performance") return hs[hs.length-1];
  if(key==="komfort") return hs[0];
  return hs[Math.floor((hs.length-1)/2)];
}
// Gravel-Faustregeln (aerycs): GCX Terra = Hybrid Strasse/Gravel (<40 mm),
// ab 40 mm ist der GCX Terra Max die bessere Wahl (60er Hoehe fuer Rennen),
// ab 50 mm der GCX Terra Ultra – Alternative dann Max bzw. guenstig Explore/Terra.
function gravelRule(m){
  if(STATE.disc!=="gravel") return 0;
  const t=STATE.tire&&STATE.tire.length?Math.max(...STATE.tire):0;
  if(!t) return 0;
  const tmin=Math.min(...STATE.tire);
  // Ultra ist erst ab 50 mm freigegeben: faehrt der Kunde auch schmaler, kann er nicht Top-Treffer sein
  if(t>=50 && tmin>=50) return {gcx_terra_ultra:2.5,gcx_terra_max:0.8,gcx_terra_travel:-1.5}[m.id]||0;
  if(t>=50) return {gcx_terra_max:1.4,gcx_terra_ultra:-1.2,gcx_terra_travel:-1.5}[m.id]||0;
  if(t>=40) return {gcx_terra_max:1.2,gcx_terra:-0.4,gcx_terra_ultra:-1.5}[m.id]||0;
  return {gcx_terra:0.5,gcx_terra_ultra:-2}[m.id]||0;
}
function scoreModel(m){
  if(!m.disc.includes(STATE.disc)) return null;
  if(m.id==="aero_cs" && entryLevel()) return null;   // Aero CS = reiner Performance-Satz, nicht fuer Alltag/Training
  const h=pickHeight(m);
  const tire=nearTire(m);
  // Priorität: Aero -> Performance-Modelle, Leicht -> leichteste, Komfort -> Komfort-Modelle
  let ch;
  if(STATE.char==="komfort") ch=m.char.komfort;
  else if(STATE.char==="aero") ch=m.char.performance;
  else if(STATE.char==="leicht") ch=lightScore(m,h);
  else ch=m.char.allround??0.6;
  const te=m.terr[STATE.terr]??0.6;
  const sf=useSf();
  const sfTerm = m.char.performance*sf + m.char.komfort*(1-sf);   // Nutzungs-Intensität
  const aeroT = (useAero()?0.4:0)*(m.char.performance-0.5) + 0.5*aeroBias()*(m.char.performance-0.5);
  const cap=(m.from-899)/900; // 0..1 Preisniveau (nur Tiebreak, keine Budgetfrage)
  const capW = (STATE.char==="aero"?0.45 : STATE.char==="leicht"?0.35 : STATE.char==="komfort"?-0.2 : 0.1) + (sf-0.55)*0.8;
  const crossPenalty = (m.disc.length>1 && m.disc[0]!==STATE.disc)?-0.15:0; // Crossover leicht nachrangig
  const sys=sysKg(); const over = sys>SYSMAX[m.id] ? -3 : (sys>SYSMAX[m.id]-5?-0.6:0); // Systemgewicht-Limit
  const score = 2.3*tire + 1.7*ch + 1.6*te + 1.3*sfTerm + aeroT + capW*cap + crossPenalty + over + gravelRule(m);
  return {m,h,tire,score};
}
function rank(){
  return MODELS.map(scoreModel).filter(Boolean).sort((a,b)=>b.score-a.score);
}
/* 3 Treffer: bester Fit + garantiert >=2 Preispunkte (ein günstigerer, ein höherwertiger wenn möglich). */
function propose(){
  let r=rank(); if(!r.length) return [];
  const cap=(!STATE.budget||STATE.budget==="open")?Infinity:+STATE.budget;
  const within=r.filter(x=>x.m.from<=cap);
  const pool=within.length?within:r;          // Fallback, falls Budget zu knapp fuer Treffer
  const hero=pool[0], rest=pool.slice(1);
  const heroP=spokeVariant(hero.m,hero.h).price;
  const priceOf=x=>spokeVariant(x.m,x.h).price;
  const cheaper=rest.find(x=>priceOf(x) < heroP-40);
  const pricier=rest.find(x=>priceOf(x) > heroP+40);
  const picks=[]; const used=new Set([hero.m.id]);
  const add=x=>{ if(x && !used.has(x.m.id)){ picks.push(x); used.add(x.m.id);} };
  add(cheaper); add(pricier);                       // >=2 Preispunkte sichtbar
  for(const x of rest){ if(picks.length>=2) break; add(x); }
  // Labels konsistent: nach Preis relativ zur Top-Wahl, günstigste Alternative zuerst
  const wp=picks.map(x=>({x,p:priceOf(x)})).sort((a,b)=>a.p-b.p);
  const heroG=spokeVariant(hero.m,hero.h).g;
  const L=new Map(); const usedL=new Set();
  wp.forEach(o=>{
    const m=o.x.m, c=m.char||{}, g=spokeVariant(m,o.x.h).g;
    const dom=["allround","komfort","performance"].reduce((a,b)=>((c[b]||0)>(c[a]||0)?b:a),"allround");
    const roles=[];
    if(o.p < heroP-40) roles.push("Günstigere Alternative");
    if(dom==="allround") roles.push("Allrounder");
    if(g!=null && heroG!=null && g < heroG-80) roles.push("Leichter");
    const hc=hero.m.char||{};
    if(dom==="komfort" && (c.komfort||0)>(hc.komfort||0)+.05) roles.push("Mehr Komfort");
    if(dom==="performance" && (c.performance||0)>(hc.performance||0)+.05) roles.push("Mehr Performance");
    if(nearTire(hero.m)>=1 && nearTire(m)<1) roles.push("Für breitere Reifen");
    if(o.p > heroP+40) roles.push("Premium");
    roles.push("Weitere Option");
    const pick=roles.find(r=>!usedL.has(r))||roles[roles.length-1];
    usedL.add(pick); L.set(o.x,pick);
  });
  const out=[{...hero,label:"Beste Übereinstimmung",kind:"hero"}];
  wp.forEach(o=>out.push({...o.x,label:L.get(o.x)||"Weitere Option",kind:"alt"}));
  return out.slice(0,3);
}

/* ---------------- Begründungstexte (variiert) ---------------- */
function terrLabel(){
  return {flach:"flachem",huegelig:"hügeligem",bergig:"bergigem",
    leicht:"leichtem",gemischt:"gemischtem",grob:"grobem"}[STATE.terr]||"gemischtem";
}
function heroWhy(p){
  return `${p.m.intro} Für ${CHAR_LABEL[STATE.char]} auf ${terrLabel()} Terrain und ${tireText()} Reifen die stimmigste Wahl – hier mit ${p.h} mm Felgenhöhe.`;
}
function altWhy(p,hero){
  if(p.m.from < hero.m.from)
    return `Rund ${EUR(hero.m.from - p.m.from).replace('€ ','')} € günstiger – ${p.m.short}. Deckt dein Profil fast genso gut ab.`;
  if(p.m.from > hero.m.from)
    return `Wenn du mehr willst: ${p.m.short}. Spürbar höherwertig als die ${hero.m.name}.`;
  return `Gleichwertige Alternative zur ${hero.m.name} – ${p.m.short}.`;
}

/* ---------------- Rendering ---------------- */
const app=()=>document.getElementById("app");
function arrow(){return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';}

function renderHero(){
  
  app().innerHTML=`<section class="hero hero--center">
    <div class="eyebrow">${T("hero_eyebrow","Laufrad-Finder")}</div>
    <h1>${T("hero_title","Finde deinen perfekten Laufradsatz.")}</h1>
    <p class="lead">${T("hero_lead","Ein paar kurze Fragen zu Terrain, Reifen und Fahrstil – wir finden aus dem echten aerycs-Sortiment die Laufräder, die wirklich zu dir passen.")}</p>
    <button class="cta-primary" onclick="FINDER.start()">${T("hero_button","Finder starten")} ${arrow()}</button>
  </section>`;
}

function renderStep(){
  
  STEPS=stepsFor(STATE.disc||"road");
  const step=STEPS[stepIdx], cfg=optionsFor(step);
  const bar=STEPS.map((s,i)=>`<div class="s ${i===stepIdx?'active':i<stepIdx?'done':''}">${i+1}. ${STEP_LABEL[s]}</div>`).join("");
  let body;
  if(cfg.type==="budget"){
    body=`<div class="bgrid">${cfg.opts.map(o=>`
      <button class="bcard" aria-pressed="${String(STATE[cfg.key])===String(o.v)}" onclick="FINDER.pick('${cfg.key}','${o.v}')">
        <span class="bcount">${budgetCount(o.v)} passend</span>
        <span class="bprice tnum">${o.b}</span>
        <span class="bsub">${o.s}</span>
      </button>`).join("")}</div>`;
  } else if(cfg.type==="multi"){
    body=`<div class="pills">${cfg.opts.map(o=>`<button class="pill" aria-pressed="${(STATE[cfg.key]||[]).includes(o.v)}" onclick="FINDER.toggleMulti('${cfg.key}',${o.v})">${o.b}</button>`).join("")}</div>`;
  } else if(cfg.type==="multiTile"){
    const grid = cfg.opts.length===2||cfg.opts.length===4?" grid2":"";
    body=`<div class="opts${grid}">${cfg.opts.map(o=>`
      <button class="opt" aria-pressed="${(STATE[cfg.key]||[]).includes(o.v)}" onclick="FINDER.toggleMulti('${cfg.key}','${o.v}')">
        <span class="ic"><svg viewBox="0 0 24 24">${ICON[o.ic]||''}</svg></span>
        <span class="tx"><b>${o.b}</b><span>${o.s}</span></span>
        <span class="chk"></span>
      </button>`).join("")}</div>`;
  } else if(cfg.type==="sliders"){
    body=`<div class="sliders">${cfg.sliders.map(s=>`
      <div class="sld">
        <div class="sld-h"><b>${s.label} <span id="${s.id}-v">${s.step<1?(+STATE[s.key]).toFixed(1):STATE[s.key]}${s.unit}</span></b><span>${s.sub}</span></div>
        <input type="range" id="${s.id}" min="${s.min}" max="${s.max}" step="${s.step}" value="${STATE[s.key]}"
          oninput="FINDER.slide('${s.key}','${s.id}-v','${s.unit}',this.value,${s.step<1})">
      </div>`).join("")}</div>
      <div class="why-note"><b>Warum wir das fragen:</b> Aus Gewicht, Körpergröße und Radgewicht schätzen wir dein <b>Systemgewicht</b> und ob eher Aerodynamik oder Leichtbau für dich zählt.</div>`;
  } else if(cfg.type==="pill"){
    body=`<div class="pills">${cfg.opts.map(o=>`<button class="pill" aria-pressed="${STATE[cfg.key]===o.v}" onclick="FINDER.pick('${cfg.key}',${o.v})">${o.b}</button>`).join("")}</div>`;
  } else {
    const grid = cfg.opts.length===2?" grid2":"";
    body=`<div class="opts${grid}">${cfg.opts.map(o=>`
      <button class="opt" aria-pressed="${STATE[cfg.key]===o.v}" onclick="FINDER.pick('${cfg.key}','${o.v}')">
        <span class="ic"><svg viewBox="0 0 24 24">${ICON[o.ic]||''}</svg></span>
        <span class="tx"><b>${o.b}</b><span>${o.s}</span></span>
        <span class="chk"></span>
      </button>`).join("")}</div>`;
  }
  const chosen = (cfg.type==="multi"||cfg.type==="multiTile") ? ((STATE[cfg.key]||[]).length>0) : cfg.type==="sliders" ? true : (STATE[cfg.key]!=null);
  const last=stepIdx===STEPS.length-1;
  app().innerHTML=`<section class="flow"><div class="finder-top"><button class="restart" onclick="FINDER.restart()">Neu starten</button></div>
    <div class="steps">${bar}</div>
    <div class="panel">
      <div class="q-kicker">Schritt ${stepIdx+1} · ${cfg.kicker}</div>
      <h2 class="q-title">${cfg.title}</h2>
      <p class="q-sub">${cfg.sub}</p>
      ${body}
      <div class="nav">
        <button class="back" ${stepIdx===0?'hidden':''} onclick="FINDER.back()">Zurück</button>
        <button class="next" id="nextBtn" ${chosen?'':'disabled'} onclick="FINDER.next()">${last?'Ergebnis anzeigen':'Weiter'}</button>
      </div>
    </div>
  </section>`;
}

function renderLoading(){
  app().innerHTML=`<section class="load">
    <div class="spin"></div>
    <h2>Wir stellen deine Empfehlung zusammen</h2>
    <p>Wir gleichen dein Profil gegen ${MODELS.filter(m=>m.disc.includes(STATE.disc)).length} Serien und alle Felgenhöhen ab.</p>
  </section>`;
}

/* --- Editierbare Ergebnis-Chips --- */
let OPEN_CHIP=null;
const CHIP_STEPS=()=>["disziplin", STATE.disc==="gravel"?"untergrund":"terrain","reifen","nutzung","charakter","budget"];
function chipLabel(step){
  if(step==="budget") return (!STATE.budget||STATE.budget==="open")?"Budget: offen":"bis "+EUR(+STATE.budget);
  if(step==="reifen") return tireText();
  if(step==="nutzung") return (STATE.use&&STATE.use.length)?STATE.use.map(x=>USE_SHORT[x]).join(", "):"—";
  const cfg=optionsFor(step); const o=cfg.opts.find(o=>String(o.v)===String(STATE[cfg.key]));
  return o?o.b:"—";
}
function editChips(){
  const chips=CHIP_STEPS().map(s=>`<button class="echip ${OPEN_CHIP===s?'open':''}" onclick="FINDER.editToggle('${s}')">${chipLabel(s)} <span class="ck">▾</span></button>`).join("");
  let drop="";
  if(OPEN_CHIP){ const cfg=optionsFor(OPEN_CHIP);
    if(cfg.type==="multi"||cfg.type==="multiTile"){
      drop=`<div class="edrop">${cfg.opts.map(o=>`<button class="ep" aria-pressed="${(STATE[cfg.key]||[]).includes(o.v)}" onclick="FINDER.toggleMultiLive('${cfg.key}','${o.v}')">${o.b}</button>`).join("")}</div>`;
    } else {
      drop=`<div class="edrop">${cfg.opts.map(o=>`<button class="ep" aria-pressed="${String(STATE[cfg.key])===String(o.v)}" onclick="FINDER.setAnswer('${cfg.key}','${o.v}')">${o.b}${(OPEN_CHIP==='budget'&&o.s)?' · '+o.s:''}</button>`).join("")}</div>`;
    }
  }
  return `<div class="echips">${chips}<span class="edit-hint">Tippe eine Angabe an, um dein Ergebnis anzupassen.</span></div>${drop}`;
}
/* --- "Warum er zu dir passt" --- */
function heroFit(p){
  const terrMap={
    flach:`Flaches Terrain belohnt die hohe ${p.h} mm Felge – maximaler Aero-Vorteil.`,
    huegelig:`Hügeliges Terrain: ausgewogenes ${p.h} mm Profil zwischen Aero und Gewicht.`,
    bergig:`Am Berg zählt Leichtbau – mit ${p.h} mm bleibt das Gewicht niedrig.`,
    leicht:`Leichter Untergrund: schnell und effizient mit ${p.h} mm.`,
    gemischt:`Gemischtes Gelände: stabil und vielseitig unterwegs.`,
    grob:`Grobes Terrain: ${p.m.iw} mm Maulweite für Grip und Kontrolle bei niedrigem Druck.`};
  const sv=spokeVariant(p.m,p.h);
  const gtxt=sv.g!=null?sv.g.toLocaleString("de-DE")+" g":"geringem Gewicht";
  const charMap={
    komfort:"Komfort-Fokus: ruhiger, satter Lauf steht im Vordergrund.",
    aero:`Aero-Fokus: ${p.h} mm Felge und ${sv.spokes} für maximales Tempo.`,
    leicht:`Leichtbau-Fokus: mit ${gtxt} eines der leichtesten Setups.`};
  const items=[terrMap[STATE.terr], `Deine ${tireText()} Reifen passen zur Empfehlung (${p.m.tire}, ${p.m.iw} mm Maulweite).`, charMap[STATE.char]].filter(Boolean);
  const chk='<svg viewBox="0 0 24 24" stroke="currentColor" fill="none" stroke-width="2.2"><path d="M5 12.5l4 4 10-10"/></svg>';
  return `<div class="whyfit"><h4>Warum er sehr gut zu dir passt</h4><ul>${items.map(t=>`<li>${chk}<span>${t}</span></li>`).join("")}</ul></div>`;
}
function specRow(p){
  const sv=spokeVariant(p.m,p.h);
  const g=sv.g!=null?sv.g.toLocaleString("de-DE")+" g":null;
  const items=[["Gesamtgewicht",g],["Nabe",p.m.hub],["Speichen",sv.spokes],["Reifenempfehlung",p.m.tire]]
    .filter(x=>x[1]);
  return `<div class="specs">${items.map(([k,v])=>`<div class="spec"><span class="k">${k}</span><span class="v">${v}</span></div>`).join("")}</div>`;
}
function starRow(id){
  const rv=REVIEWS[id]; if(!rv||!rv.n) return "";
  const full=Math.max(0,Math.min(5,Math.round(rv.r)));
  return `<div class="ruk_rating_snippet"><span class="aerycs-stars">${"★".repeat(full)}<span class="aerycs-stars-off">${"★".repeat(5-full)}</span></span><span class="ruk-rating-snippet-count">${rv.n} Reviews</span></div>`;
}
function cap(s){ s=String(s||""); return s.charAt(0).toUpperCase()+s.slice(1); }
// Nabenname ohne Farbangabe fuer Fliesstexte ("DT Swiss 240 Grey" -> "DT Swiss 240")
const HUB_COLORS=/\s+(grey|gray|grau|black|schwarz|silver|silber|white|weiß|weiss|red|rot|blue|blau|gold|orange|green|grün|titan|anthrazit)\b/gi;
function hubName(h){ return (h||"").replace(HUB_COLORS,"").trim(); }
function joinDe(a){ return a.length<2?(a[0]||""):a.slice(0,-1).join(", ")+" und "+a[a.length-1]; }
// Pflicht-Hinweis, wenn ein Modell erst ab einer Mindest-Reifenbreite freigegeben ist
const MIN_TIRE={gcx_terra_ultra:50};
function minTireNote(m){
  const mt=MIN_TIRE[m.id]; if(!mt||!STATE.tire||!STATE.tire.length) return "";
  const below=STATE.tire.filter(t=>t<mt); if(!below.length) return "";
  return ` Wichtig: Wir geben den ${m.name} erst ab ${mt} mm Reifenbreite frei – mit ${below.join("/")} mm Reifen passt er nicht.`;
}
function cardText(p,hero,isBest){ return cardTextBase(p,hero,isBest)+minTireNote(p.m); }
function cardTextBase(p,hero,isBest){
  // Bezug auf ein anderes Modell nur, wenn genau das die Top-Empfehlung ist
  const short=(!isBest && p.m.shortVs[hero.m.id]) || p.m.short || "";
  if(isBest) return `${short}. Passt am besten zu ${CHAR_LABEL[STATE.char]||"deinem Profil"} auf ${terrLabel()} Terrain mit ${tireText()} Reifen.`;
  const a=spokeVariant(p.m,p.h), b=spokeVariant(hero.m,hero.h);
  const dP=Math.round((a.price-b.price)/10)*10, dW=(a.g!=null&&b.g!=null)?a.g-b.g:0;
  const fitA=nearTire(p.m)>=1, fitB=nearTire(hero.m)>=1;
  const hA=hubName(p.m.hub), hB=hubName(hero.m.hub), hubDiff=hA&&hB&&hA!==hB;
  if(dP<=-40){
    const t=[];
    if(hubDiff) t.push(`Nabe ${hA} statt ${hB}`);
    if(dW>=40) t.push(`etwas mehr Gewicht (+${dW.toLocaleString("de-DE")} g)`);
    if(fitB&&!fitA) t.push(`nicht ganz so optimal auf ${tireText()} Reifen abgestimmt`);
    if(!t.length) t.push((p.m.char.performance||0)<(hero.m.char.performance||0)?"etwas weniger auf Tempo ausgelegt":"kleine Abstriche bei der Ausstattung");
    return `${short}. Rund ${Math.abs(dP)} € günstiger als die ${hero.m.name} – dafür ${joinDe(t)}.`;
  }
  if(dP>=40){
    const g=[];
    if(hubDiff) g.push(`Nabe ${hA} statt ${hB}`);
    if(dW<=-40) g.push(`${Math.abs(dW).toLocaleString("de-DE")} g leichter`);
    if(fitA&&!fitB) g.push(`besser auf ${tireText()} Reifen abgestimmt`);
    if(!g.length) g.push("eine Stufe höher ausgestattet");
    return `${short}. Rund ${dP} € mehr als die ${hero.m.name} – dafür ${joinDe(g)}.`;
  }
  return `${short}. Preislich ähnlich wie die ${hero.m.name} – eine passende Alternative.`;
}
// Link direkt auf die empfohlene Variante (Hoehe + Speichentyp)
function variantImg(p,sv){
  const v=VID[p.m.id]&&VID[p.m.id][p.h]; const sc=SPOKE_MODELS[p.m.id];
  return (v&&((sc&&sv.price===sc.carbonPrice&&v.imgCarbon)||v.imgSteel))||IMG[p.m.id]||"";
}
function variantUrl(p,sv){
  const v=VID[p.m.id]&&VID[p.m.id][p.h]; const sc=SPOKE_MODELS[p.m.id];
  const id=v&&((sc&&sv.price===sc.carbonPrice&&v.carbon)||v.steel);
  return id?`${p.m.url}${p.m.url.includes("?")?"&":"?"}variant=${id}`:p.m.url;
}
function kachel(p,isBest,hero){
  const sv=spokeVariant(p.m,p.h); const sl=sealImg(p.m.id,p.h);
  const g=sv.g!=null?sv.g.toLocaleString("de-DE")+" Gramm":"—";
  // Kleine Einblendung, wenn es das Modell auch mit Carbonspeichen gibt
  const sc=SPOKE_MODELS[p.m.id]; let spokeHint="";
  const isCarbon=!!(sc&&sv.price===sc.carbonPrice);
  if(sc&&!isCarbon){   // Upgrade-Hinweis nur, wenn die Stahl-Variante empfohlen wird
    const cg=sc.carbonG[p.h], sg=weightG(p.m.id,p.h), dg=(cg!=null&&sg!=null)?sg-cg:null;
    spokeHint = `Auch mit Carbonspeichen für ${EUR(sc.carbonPrice)} erhältlich.${dg>0?` Damit sparst du nochmal ${dg.toLocaleString("de-DE")} g.`:""}`;
  }
  return `<div class="alle-laufraeder-kachel${isBest?' aerycs-best':''}">
  <a href="${variantUrl(p,sv)}" target="_blank" rel="noopener">
    ${sl?`<div class="badge-container"><div class="badge--custom"><img src="${sl}" alt="Testsiegel"></div></div>`:''}
    <img src="${variantImg(p,sv)}" loading="lazy" alt="${p.m.name}" width="411" height="411">
    <div class="headline-container">
      <div class="text-badge-container"><div class="text-badge">${p.label}</div>${isCarbon?'<div class="text-badge aerycs-cs-badge">Carbonspeichen</div>':''}</div>
      <div class="title-review-container">
        <div class="h3">${p.m.name}</div>
        <div class="product_modell h3">${p.h}</div>
      </div>
    </div>
    <div class="features-container">
      <div class="feature weight"><div>Gewicht</div><div class="value">${g}</div></div>
      ${p.m.hub?`<div class="feature Nabe"><div>Nabe</div><div class="value">${p.m.hub}</div></div>`:''}
      ${p.m.tire?`<div class="feature Reifenbreite"><div>Ideale Reifenbreite</div><div class="value">${p.m.tire}</div></div>`:''}
    </div>
    <div class="aerycs-why">${cardText(p,hero,isBest)}</div>
    ${spokeHint?`<div class="aerycs-spoke"><span class="dot"></span>${spokeHint}</div>`:""}
    <div class="price-button-container">
      <div class="h5"><price-list class="price-list"><sale-price class="h4">${euroC(sv.price)}</sale-price></price-list></div>
      <div class="button button-primary button--full-width"><span class="button__text">Zum Produkt</span></div>
    </div>
  </a>
</div>`;
}
function renderResults(){
  const props=propose(), hero=props[0];
  const hv=spokeVariant(hero.m,hero.h);
  const cards=props.map((p,i)=>kachel(p,i===0,hero)).join("");
  app().innerHTML=`<section class="res">
    <div class="res-head"><h2 class="rt">${T("res_title","Unsere Empfehlung basierend auf deinen Angaben")}</h2><button class="restart" onclick="FINDER.restart()">Neu starten</button></div>
    ${editChips()}
    <div class="rec-grid alle-laufraeder">${cards}</div>
    <div class="swipe-hint">← wischen für Alternativen →</div>
    <div class="contact">
      <div class="cbox"><h3>${T("contact_title","Noch unsicher? Sprich mit uns.")}</h3>
        <p>${T("contact_text","Unsere Laufrad-Expert:innen helfen dir persönlich weiter – von der Reifenwahl bis zum Systemgewicht.")}</p>
        <a href="${T("contact_url","/pages/service#shopify-section-template--28413122838794__multi_column_Um8jAC")}">${T("contact_button","Beratung anfragen")}</a></div>
      <div class="cbox"><h3>${T("config_title","Etwas ganz Individuelles?")}</h3>
        <p>${T("config_text","Nabe, Speichen, Felgenhöhe und Farbe frei kombinieren – im Laufrad-Konfigurator.")}</p>
        <a href="${T("config_url","/pages/laufrad-konfigurieren")}">${T("config_button","Zum Konfigurator")}</a></div>
    </div>
    <div class="res-foot"><button class="restart" onclick="FINDER.restart()">Neu starten</button></div>
  </section>`;
  window.scrollTo({top:0,behavior:"smooth"});
}

/* ---------------- Controller ---------------- */
const FINDER={
  start(){ resetState(); renderStep(); },
  restart(){ renderHero(); },
  pick(key,val){ STATE[key]=val; if(key==="disc"){STEPS=stepsFor(val);} renderStep(); },
  next(){
    STEPS=stepsFor(STATE.disc);
    if(stepIdx<STEPS.length-1){ stepIdx++; renderStep(); }
    else { renderLoading(); setTimeout(renderResults, 1200); }
  },
  back(){ if(stepIdx>0){ stepIdx--; renderStep(); } },
  editToggle(step){ OPEN_CHIP = OPEN_CHIP===step?null:step; renderResults(); },
  setAnswer(key,val){
    if(key==="tire") val=+val;
    if(key==="disc" && val!==STATE.disc){
      STATE.disc=val;
      STATE.terr = val==="gravel"?"gemischt":"flach";
      STATE.tire = val==="gravel"?[45]:[30];
      STATE.use=[];
    } else { STATE[key]=val; }
    OPEN_CHIP=null; renderResults();
  },
  toggleMulti(key,val){ if(key==="tire")val=+val; const a=STATE[key], i=a.indexOf(val); if(i>=0)a.splice(i,1); else a.push(val); renderStep(); },
  toggleMultiLive(key,val){ if(key==="tire")val=+val; const a=STATE[key], i=a.indexOf(val); if(i>=0){ if(a.length>1)a.splice(i,1); } else a.push(val); renderResults(); },
  slide(key,vid,unit,val,isFloat){ STATE[key]=isFloat?parseFloat(val):parseInt(val,10); const el=document.getElementById(vid); if(el)el.textContent=(isFloat?STATE[key].toFixed(1):STATE[key])+unit; },
};
function __aerycsBoot(){
  if(!document.getElementById("app")) return;
  try{ initShopify(); }catch(e){ console.warn("AERYCS init", e); }
  resetState(); renderHero();
}
document.addEventListener("shopify:section:load", __aerycsBoot);
document.addEventListener("shopify:section:select", __aerycsBoot);
if(document.readyState==="loading"){ document.addEventListener("DOMContentLoaded", __aerycsBoot); } else { __aerycsBoot(); }